// import {
//   Info as Icon
// } from 'components/icons';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="options" {...props} />;
}

export const meta = {
  id: 'CMSSettings',
  title: 'CMSSettings',
  category: 'CMS',
  exposes: [
    {
      title: 'CMS Settings',
      action: { module: 'CMSSettingsDetails', props: { /* */ } },
    },
    // {
    //   title: 'Themes',
    //   action: { module: 'CMSSettings', props: { /* */ } },
    // },
    // {
    //   title: 'Templates',
    //   action: { module: 'CMSSettings', props: { /* */ } },
    // },
    // {
    //   title: 'Analytics',
    //   action: { module: 'CMS', props: { /* */ } },
    //   desription: 'general-desc',
    // },
    {
      title: 'Integrations',
      action: { module: 'CMSIntegrations', props: { /* */ } },
      desription: 'general-desc',
    },
  ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `The settings to be used related to the CMS for the tenant`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
